import { type FC, useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';

import { useDebouncedDispatch } from '@editor2/hooks/useDebouncedDispatch';
import { updateElement } from '@editor2/reducers/editor/editorSlice';
import { elementCommonStyles } from '@editor2/styles/element';
import { type PollResults } from '@editor2/types/pageElements';

interface Props {
	element: PollResults;
	courseId: number;
}

const PollResultsElement: FC<Props> = (props) => {
	const { element, courseId } = props;

	const commonPayload = { elementId: element.family_id, courseId };

	const [pollFamilyId, setPollFamilyId] = useState(element.poll_question_family_id);

	useEffect(() => {
		if (element.poll_question_family_id !== pollFamilyId)
			setPollFamilyId(element.poll_question_family_id);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [element]);

	const debouncedDispatch = useDebouncedDispatch();

	const handleDebouncedChange = (value) => {
		setPollFamilyId(value.poll_question_family_id);
		debouncedDispatch(updateElement({ ...commonPayload, ...value }));
	};

	return (
		<Form.Group className={elementCommonStyles}>
			<Form.Label>Poll Family Id</Form.Label>
			<Form.Control
				value={pollFamilyId}
				onChange={(e) => handleDebouncedChange({ poll_question_family_id: e.target.value })}
			/>
		</Form.Group>
	);
};

export default PollResultsElement;
